import { routes, useRouteMatch } from "../lib/urls";
import { useHasAccess } from "./useHasAccess";

export function useAdminLandingView(): boolean {
  const canReadSpaces = useHasAccess("tenant:spaces_read");
  const canReadChats = useHasAccess("tenant:personal_chats_read");
  const [onWatchtower] = useRouteMatch(routes.watchtower);
  return onWatchtower && (canReadSpaces || canReadChats);
}
